import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { Extras, ExtrasDetails, ExtrasPayload } from '../../common/models'
import { UsableExtras } from '../../common/models/addons'
import { Country } from '../../common/models/locale'

export const createExtra = (data: ExtrasPayload) =>
  http.post<ExtrasDetails>(`/operations/extras`, { ...data })

export const getAllExtras = (params?: PaginationParams) =>
  http.get<Pagination<Extras>>(`/operations/extras`, {
    params,
  })

export const getExtra = (id: string) =>
  http.get<ExtrasDetails>(`/operations/extras/${id}`)

export const deleteExtra = (ids: string[]) =>
  http.delete('/operations/extras', {
    data: {
      ids,
    },
  })

export const updateExtra = (id: string, data: ExtrasPayload) =>
  http.put<ExtrasDetails>(`/operations/extras/${id}`, { ...data })

export const unpublishExtras = (ids: string[]) =>
  http.put<ExtrasDetails[]>('/operations/extras/unpublish', { ids })

export const publishExtras = (ids: string[]) =>
  http.put<ExtrasDetails[]>('/operations/extras/publish', { ids })

export const getAllCountries = () =>
  http.get<Country[]>(`/operations/utils/general/countries`)

export const getUsableExtra = () =>
  http.get<UsableExtras[]>(`/operations/extras/usable`)
